import type { ThemeMode } from '@/hooks/useLightMode'

import { tokenPrefix } from '@hivewatch/dark'

import { getIncidentSurfaceTokens } from '@/utils/incidentSurfaceTokens'

/**
 * Dark-package semantic tokens for the notifications tab, drawers and their
 * shared shell. Extends the shared incident-surface base
 * (`getIncidentSurfaceTokens`) with the tab-specific icon/row/accent tokens.
 */
export const getNotificationsTabTokens = (mode: ThemeMode) => {
  const p = tokenPrefix(mode) // '' | 'light.'
  return {
    ...getIncidentSurfaceTokens(mode),
    icon: `${p}icon.secondary`,
    panelShadow: mode === 'light' ? 'panel-light' : 'panel-dark',
    rowHover: `${p}bg.table-row-hover`,
    // Incident-accent (the red active-incidents cell).
    incidentBg: `${p}bg.badge-incident`,
    incidentFg: `${p}text.badge-incident`,
  }
}
